"use client";

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from "next-intl";
import { useAppContext } from "@/app/contextProviders/app-context";
declare global {
  var QSI: {
    API?: {
      unload?: () => void;
      load?: () => {
        done: (cb: () => void) => void;
      };
      run?: () => void;
    };
  } | undefined;
}
function handleFeedbackClick() {
  const api = globalThis.QSI?.API;
  if (!api?.unload || !api.load || !api.run) return;
  api.unload();
  api.load().done(() => api.run!());
}
export function FeedbackButton(t0) {
  const $ = _c(5);
  const {
    className
  } = t0;
  const {
    featureFlags
  } = useAppContext();
  const t = useTranslations("FeedbackButton");
  if (featureFlags.disableFeedbackButton) {
    return null;
  }
  let t1;
  if ($[0] !== t) {
    t1 = t("label");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== className || $[3] !== t1) {
    t2 = <button className={className} onClick={handleFeedbackClick}>{t1}</button>;
    $[2] = className;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}